exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".event-text {\n  display: flex;\n  flex-direction: column;\n  font-size: 1.15em; }\n  .event-text .text {\n    line-height: 1.38; }\n  .event-text .footer {\n    margin-top: 3.5rem;\n    width: 100%; }\n  .event-text .print, .event-text .toggle {\n    float: left;\n    display: flex;\n    align-items: center;\n    color: #8b3187;\n    cursor: pointer;\n    line-height: 1;\n    margin: 1rem;\n    margin-left: 0; }\n    .event-text .print .anticon, .event-text .toggle .anticon {\n      margin: 0 1rem; }\n  .event-text .hidden {\n    display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/pages/EventDetailPage/EventText/EventText.scss
// module id = 1556
// module chunks = 0